// Mobile nav toggle for the server-rendered SEO navbars. Replaces Bootstrap's
// `data-toggle="collapse"` behavior: a `[data-nav-toggle]` button flips a
// `data-open` attribute + `aria-expanded` on the panel named by its
// `aria-controls`. The panel's own Tailwind classes (`max-md:data-[open]:flex`)
// handle showing/hiding — this only manages the attribute state.
function initNavToggles(): void {
  const toggles =
    document.querySelectorAll<HTMLButtonElement>('[data-nav-toggle]');
  toggles.forEach((toggle) => {
    const targetId = toggle.getAttribute('aria-controls');
    if (!targetId) return;
    const panel = document.getElementById(targetId);
    if (!panel) return;

    toggle.addEventListener('click', () => {
      const isOpen = panel.hasAttribute('data-open');
      if (isOpen) {
        panel.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Bootstrap's dropdown JS closed an open menu on any click outside it
  // (including the other menu's trigger); mirror that for the <details>
  // dropdowns — both the navbar menus and the state/city breadcrumb.
  document.addEventListener('click', (event) => {
    document
      .querySelectorAll<HTMLDetailsElement>(
        'nav details[open], .state-navbar details[open]'
      )
      .forEach((menu) => {
        if (!menu.contains(event.target as Node)) {
          menu.removeAttribute('open');
        }
      });
  });
}

export default initNavToggles;
